<template>
    <div class="possible-efforts-sub-menu">
        <div class="switcher">
            <div class="item" :class="{'selected': selectedItem === 'makingMoney'}" @click="selectedItem = 'makingMoney'">
                <span>{{ texts.makingMoney.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'makingMoney'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
            <div class="item" :class="{'selected': selectedItem === 'smallAndBig'}" @click="selectedItem = 'smallAndBig'">
                <span>{{ texts.smallAndBig.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'smallAndBig'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
        </div>
        <div v-show="selectedItem === 'makingMoney'">
            <div class="lg">
                {{ texts.makingMoney.tykTekst1 }}
                {{ customersMakingMoneyRange ? customersMakingMoneyRange[0] : 0 | currency }} til {{ customersMakingMoneyRange ? customersMakingMoneyRange[1] : 0 | currency }} i timen
            </div>
            <div class="sub" v-html="texts.makingMoney.tyndTekst1">
                {{ texts.makingMoney.tyndTekst1 }}
            </div>
            <div class="g-table-wrapper">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="customers.customerRevenue" />
                        Er de største kunder lønsomme?
                    </div>
                    <div class="placeholder">
                        
                        <vue-good-table
                            :columns="customersColumns"
                            :rows="data.making_money.table"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name">
                                    {{ props.row.name }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'">
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'timelog_hours_total'">
                                    {{ props.row.timelog_hours_total | number }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else :title="props.formattedRow[props.column.field]">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                    </div>
                </div>
            </div>
            <div class="foot">
                <div class="button" @click="goToRoute('CustomersLearning', 'customerRevenue')">
                    Gå til alle kunder &rarr;
                </div>
            </div>
        </div>
        <div v-show="selectedItem === 'smallAndBig'">
            <div class="lg">
                {{ texts.smallAndBig.tykTekst1 }}
                {{ smallAndBigRange[0].coverage_per_hour | currency }} og {{ smallAndBigRange[1].coverage_per_hour | currency }} pr. time
            </div>
            <div class="sub" v-html="texts.smallAndBig.tyndTekst1">
                {{ texts.smallAndBig.tyndTekst1 }}
            </div>
            <div class="g-table-wrapper">
                <div class="placeholder fit-content">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="customers.customerGroups" />
                        Kan vi tjene penge på både små og store kunder?
                    </div>
                    <div class="placeholder">
                        
                        <vue-good-table
                            :columns="smallAndBigColumns"
                            :rows="data.small_and_big.table"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'">
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'bracket'">
                                    {{ props.row.bracket }} kr.
                                </div>
                                <div v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                    </div>
                </div>
            </div>
            <div class="foot">
                <div class="button" @click="goToRoute('CustomersLearning', 'customerRevenueGrouped')">
                    Gå til alle kunder &rarr;
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['selectedBox', 'data', 'customersMakingMoneyRange', 'smallAndBigRange', 'texts'],
    data () {
        return {
            selectedItem: 'makingMoney',
            customersColumns: [
                { label: 'Kunde', field: 'name', type: 'string' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'Antal timer', field: 'timelog_hours_total', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }
            ],
            smallAndBigColumns: [
                { label: 'Omsætning pr. kunde', field: 'name', type: 'string', sortable: false },
                { label: 'Kunder', field: 'customers_count', type: 'number' },
                { label: 'Omsætning i alt', field: 'invoices_total', width: '10%', type: 'number' },
                { label: 'DB', field: 'coverage', width: '10%', type: 'number' },
                { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }
                // { label: '', field: 'action', width: '5%', type: 'string', filterable: false }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    methods: {
        goToRoute (parent, child) {
            this.$router.push({
                name: parent,
                params: {
                    selectedItem: child
                },
                query: {
                    tab: child
                }
            })
        }
    },
    watch: {
        selectedBox () {
            if (this.selectedBox) {
                this.selectedItem = this.selectedBox
            } else {
                this.selectedItem = 'makingMoney'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// customers.vue?3b851cfc